import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Label, Input, NavbarBrand } from 'reactstrap';
import '../css/Login.css';
import '../css/OverlayLoader.css';
import { forgotPasswordService, userResponseService } from '../../api/userapi';
import { Container } from 'reactstrap';
import { customLoadingOverlay } from '../css/CustomLoadingOverlay'
import LoadingOverlay from 'react-loading-overlay-ts'

class Forgotpassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            submitted: false,
            loading: false,
            success: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        if(this.state.prevEmail != value)
        {
        this.setState({ submitted: false })
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true});
        const { email,  } = this.state;
        if (email) {    
            this.setState({ loading: true , prevEmail : email  });        
            this.props.forgotPasswordConnect(email);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.userReponse!==null){
            if(prevProps.userReponse.data){
                if(prevProps.userReponse.data.success==true){
                    this.props.userResponseConnect(null);
                    this.setState({ loading: false });
                    return;
                }
            }
        }

        if(this.props.userReponse!==null){
            if(this.props.userReponse.data) {
                if(this.props.userReponse.data.success && prevState.loading){
                  this.setState({ loading: false, success: true });
                }
            }                    
        }

        if(this.props.userReponse!==null){
            if(this.props.userReponse.data) {
                if(!this.props.userReponse.data.success && prevState.loading){
                  this.setState({ loading: false});
                }
            }                    
        }
    }
 
     render() {
        const { email, submitted, loading, success } = this.state;
        let userReponse = this.props.userReponse;

        let messages = '';
        if(userReponse){
            if(userReponse.data){
                if(!userReponse.data.success){
                    messages = userReponse.data.errors.map((item) =>
                    <li key={item.errorCode} >{item.message}</li>);
                }              
            }
        }

        return (
            <Container>
                <LoadingOverlay active={loading} spinner styles={customLoadingOverlay} >
                    <div className="col-md-12">
                    <br></br> <br></br>
                    <br></br> <br></br>
                    <div className="d-flex justify-content-center">
                        <NavbarBrand tag={Link} to="/"><img src="./aaa_logo.png" alt="logo" className="title-logo" /></NavbarBrand>
                    </div>
                    <div className="d-flex justify-content-center">
                        <h5 className="title-login-logo"> GIFT CENTER PORTAL </h5>
                    </div>
                    <br></br>
                    <br></br>
                    
                    <div className="d-flex justify-content-center">
                        { !success  && <p className="title-forgot-password"> Enter your email address and we'll send you
                                        <br></br>
                                    a link to reset your password. 
                                    </p>
                        } 
                        {
                            success && <p className="title-forgot-password">
                                We sent you an email.
                            </p>

                        }
                    </div>
                    
                    <div className="d-flex justify-content-center">
                        { !success && <Form name="form" onSubmit={this.handleSubmit} className="col-md-5 user-text">                    
                            <div className={'form-group' + (submitted && !email ? ' has-error' : '')}>
                                <Label className='mt-4' htmlFor="email"> <strong>Email address</strong></Label>
                                <Input  type="email"
                                        name="email"
                                        className='input-editable'
                                        value={email}
                                        onChange={this.handleChange}/>
                                {submitted && !email &&
                                    <span className="help-block">Value is required.</span>
                                }
                                {email && submitted && <ul className="errors-list-forgot">{messages}</ul>}
                            </div>
                            <div className="form-group">
                                <div className="d-flex justify-content-center">
                                    <button className="btn mt-4" >SUBMIT</button>
                                </div>
                            </div>
                        </Form>}
                        {
                            success  && <p className="text-center user-text">
                                Check your email {email} and follow the <br></br>instructions to finish with the recovery of your password.
                                </p>
                        }
                    </div>
                    </div> 
                </LoadingOverlay>
            </Container>
        );
    }
}

export default connect(
    state => {
        return {
            userReponse: state.data.userReponse
        }
    },
    dispatch => ({
        forgotPasswordConnect: (email) => { dispatch(forgotPasswordService(email)) },
        userResponseConnect: (response)=>{ dispatch(userResponseService(response)) }
    })
)(Forgotpassword);